import { useMarketsContext } from './MarketContext';
import { PAGES } from './MarketDashboard';
import { logger } from '../../helpers/logger';

export const AssetTypesMenu = () => {
  const { assetType, setAssetType, setAssetExchange } = useMarketsContext();

  return (
    <div className={`grid grid-cols-${PAGES.length} gap-5 w-full mt-5`}>
      {PAGES.map((title) => (
        <div
          key={title}
          className="p-3 cursor-pointer dark:bg-grey-90"
          onClick={() => {
            setAssetType(title);
            setAssetExchange(title === 'STOCK' ? 'NASDAQ' : '');
          }}
        >
          <div
            className={`
              flex
              justify-center
              border-b-4
              py-3
              text-sm
              font-medium
              border-${title === assetType ? 'primary' : 'transparent'}
              dark:text-grey-${title === assetType ? 50 : 30}
              ${title === assetType ? `font-bold` : 'text-grey-50'}
            `}
          >
            {title === 'FOREX' ? 'CURRENCY' : title}
          </div>
        </div>
      ))}
    </div>
  );
};
